import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {MarketSeriesManager} from '../market-series-manager';
import {EventBank, MonthColumn, PolicyEvent, YearRow} from '../policy-chart.models';

@Component({
  selector: 'app-fiscal-month-events',
  standalone: true,
  imports: [],
  templateUrl: './fiscal-month-events.html',
  styleUrl: './fiscal-month-events.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiscalMonthEvents {
  private readonly seriesManager = inject(MarketSeriesManager);

  @Input({required: true}) year!: YearRow;

  /**
   * Only the Fed's calendar is listed under the chart. Every other bank is read
   * off the rate table, which now carries its dates.
   */
  visibleEvents(column: MonthColumn): PolicyEvent[] {
    return column.events.filter((event) => event.bank === 'FED');
  }

  bankColor(bank: EventBank): string {
    return this.seriesManager.bankColor(bank);
  }
}
